import { PageTemplate, HeaderTemplate, Button, ButtonLink } from "../styles";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import styled from "styled-components";
import { supportRequest } from "../api/user";
import toast from "react-hot-toast";
import { SuccessIcon } from "../svgs";
import { useNavigate } from "react-router-dom";

const SupportStyles = styled.div`
  label {
    padding: 10px 30px;
    font-weight: 700;
  }
  textarea {
    margin-bottom: 20px;
  }
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    color: var(--white);
    background-color: var(--green);
    border-radius: 100px;
    width: fit-content;
    margin: 0 auto;
    padding: 8px 40px;
    cursor: pointer;
    text-transform: uppercase;
    border: 0;
  }
`;

const OrderNumber = styled.p`
  background-color: var(--dark-grey-highlight);
  color: var(--white);
  border-radius: 5px;
  padding: 20px 30px;
  margin-bottom: 20px;
  span {
    font-weight: 700;
  }
  @media only screen and (max-width: 991px) {
    padding: 20px;
  }
`;

const Support = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (state === null) {
      navigate("/order-lookup");
    }
  }, [state, navigate]);

  const handleSupportSubmit = async (e) => {
    e.preventDefault();
    const message = e.target.message.value;
    const response = await supportRequest({ orderNumber: state?.orderNumber, message });
    if (response.status === 200) {
      setFormSubmitted(true);
    } else {
      toast.error("Form Submission Failed");
    }
  };

  if (!state) return null;

  return (
    <SupportStyles>
      <HeaderTemplate className="narrow">
        <div className="header flex-header">
          <>
            <div className="title">
              <h1>Customer Support</h1>
            </div>
            {state?.previousUrl && (
              <div className="breadcrumb">
                <ButtonLink to={state.previousUrl} className="small clear">
                  Go Back
                </ButtonLink>
              </div>
            )}
          </>
        </div>
      </HeaderTemplate>
      <PageTemplate className="narrow">
        <OrderNumber>Order # {state.orderNumber}</OrderNumber>
        {formSubmitted ? (
          <div className="content-page">
            <SuccessIcon className="centered-icon" />
            <h2 className="center">Form Submitted Successfully</h2>
          </div>
        ) : (
          <form className="content-page-form" onSubmit={(e) => handleSupportSubmit(e)}>
            <Form.Group className="form-group">
              <Form.Control as="textarea" placeholder="Let us know how we can help!" name="message" rows={10} />
            </Form.Group>
            <Button type="submit">submit</Button>
          </form>
        )}
      </PageTemplate>
    </SupportStyles>
  );
};

export default Support;
